import {
  mdiEarthRemove,
  mdiEarthPlus
} from '@mdi/js'
import data from '@iez/lib/data/'
import user from '@iez/lib/user/'
import { computed, reactive } from '@vue/composition-api'
import createOnClick from '@iez/lib/create-on-click/'

const fields = [
  `id`, {
    association: [
      `id`
    ],
    requestToBecomeAssociation: [
      `id`
    ]
  }
]

const getAssociationRequestMenuItem = ({
  requestToBecomeAssociation
}) =>
  !requestToBecomeAssociation?.id
    ? ({
      label: `Demander un compte asso`,
      icon: mdiEarthPlus,
      onClick: createOnClick({
        askForAssociationAccount: async () => {
          const [{ id }] = await data.set({
            root: 'requestsToBecomeAssociation',
            items: [{
              userId: user.id
            }],
            fields: [
              'id', {
                user: [
                  `id`, {
                    requestToBecomeAssociation: [
                      `id`
                    ]
                  }
                ]
              }
            ]
          })
          await data.update({
            root: `users`,
            id: user.id,
            _set: {
              requestToBecomeAssociationId: id
            },
            fields
          })
        }
      })
    }) : ({
      label: `Annuler demande compte asso`,
      icon: mdiEarthRemove,
      onClick: async () => {
        await data.remove({
          root: 'requestsToBecomeAssociation',
          ids: requestToBecomeAssociation.id,
          parents: []
        })
      }
    })

export default () => {
  const state = reactive({
    me: data.me({
      fields
    }),
    isAssociation: computed(
      () => state.me?.association?.id
    ),
    requestToBecomeAssociation: computed(
      () => state.me?.requestToBecomeAssociation
    )
  })
  return computed(
    () => !state.isAssociation
      ? getAssociationRequestMenuItem({
        requestToBecomeAssociation: state.requestToBecomeAssociation
      }) : null
  )
}